import { NetworkEnums } from '../../../../shared/GameEnums.ts';
import { MatchmakingState } from '../../../../shared/matchmaking/MatchmakingInterfaces.ts';
import { SocketMatchmakingSend } from './SocketMatchmakingSend.ts';
import { ErrorsMatchmaking } from '../../../../shared/errors/ErrorsMatchmaking.ts';
import { ErrorDefault } from '../../../../shared/errors/Errors.ts';
import { HTTPStatus } from '../../../../shared/errors/ErrorEnums.ts';
import { ErrorsGeneral } from '../../../../shared/errors/ErrorsGeneral.ts';
import { ErrorsLeaderboard } from '../../../../shared/errors/ErrorsLeaderboard.ts';
import { ErrorsRanked } from '../../../../shared/errors/ErrorsRanked.ts';
export class SocketMatchmakingListen {
    constructor(socketController, socketActionController){
        this.matchmakingStateHandlers = new Map();
        this.socketActionController = socketActionController;
        socketController.setStateHandler(NetworkEnums.State.MatchmakingStateUpdate, (data)=>{
            var _this_matchmakingStateHandlers_get;
            (_this_matchmakingStateHandlers_get = this.matchmakingStateHandlers.get(data.type)) === null || _this_matchmakingStateHandlers_get === void 0 ? void 0 : _this_matchmakingStateHandlers_get(data.payload);
        });
        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingUpdate, (matchmakingStatusUpdate)=>{
            this.socketActionController.onMatchmakingUpdate(matchmakingStatusUpdate);
        });
        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingError, (error)=>{
            this.socketActionController.onMatchmakingError(convertMatchMakingError(error));
        });
        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingReconnect, (data)=>{
            SocketMatchmakingSend.sendFindGame();
        });
    }
}
function convertMatchMakingError(error) {
    switch(error.error){
        case 'serverUpdating':
            return new ErrorsMatchmaking.ServerUpdating();
        case 'alreadySearchingForMatch':
            return new ErrorsMatchmaking.AlreadySearchingForMatch();
        case 'queuePaused':
            return new ErrorsMatchmaking.QueueUpdating();
        case 'server':
            return new ErrorsMatchmaking.InternalServerError();
        case 'invalidRequest':
            return new ErrorsMatchmaking.InvalidRequest();
        case 'outdatedClient':
            return new ErrorDefault({
                key: 'strings:popups.errors.newVersion.refreshClient'
            }, {
                key: 'strings:popups.errors.general.title'
            }, HTTPStatus.Conflict);
        case 'banned':
            return new ErrorsGeneral.UserBanned(error.bannedUntil);
        case 'noFreeGamesRemaining':
            return new ErrorsMatchmaking.NoFreeGamesRemaining();
        case 'shuffle.notEnoughGamesPlayed':
            return new ErrorsMatchmaking.ShuffleLocked(error.gamesPlayed, error.gamesRequired);
        case 'leaderboardsDisabled':
            return new ErrorsLeaderboard.LeaderboardDisabled();
        case 'noActiveRankedSeason':
            return new ErrorsRanked.NoActiveSeason();
        case 'ranked.notEnoughGamesPlayed':
            return new ErrorsMatchmaking.RankedLocked(error.gamesPlayed, error.gamesRequired);
        case 'notLoggedIn':
            return new ErrorsRanked.MustLogin();
        case 'noCitiesAndKnightsAccess':
            return new ErrorsRanked.NoAccessToCitiesAndKnights();
        case 'alreadyPlayingRankedGame':
            return new ErrorsMatchmaking.AlreadyPlayingRankedGame();
    }
    return new ErrorsMatchmaking.InternalServerError();
}
